import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Flex, FuelerIcon, Text, Button, Loader } from '../components';
import LogSummary from './LogSummary';

const UploadIcon = styled(FuelerIcon)`
    margin: auto 0;
`;

const ConfirmationContainer = Flex.extend`
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    background: ${props => props.theme.primaryBackgroundColor};
    margin: 25px 25px;
    border-radius: 5px;
    height: 75%;
    padding: 10px;
`;

const ConfirmationContent = Flex.extend`
    width: 100%;
    height: 100%;
    align-items: center;
`;

const SummarySection = Flex.extend`
    align-items: center;
    overflow-x: hidden;
    overflow-y: auto;
    flex: 2;
    max-width: 630px;
    width: 100%;
`;

const IconContainer = styled.div`
    width: 75px;
    align-self: center;
`;

const ButtonRow = Flex.extend`
    width: 100%;
    justify-content: space-around;
    align-self: center;
    padding: 20px 0;
    @media (min-width: 768px) {
        max-width: 630px;
    }
`;

const CancelButton = Button.extend`
    flex: 1 40%;
    margin: 0 24px 0 12px;
`;

const SubmitButton = Button.extend`
    flex: 1 60%;
    margin: 0 12px 0 24px;
    display: flex;
    justify-content: center;
`;

const SummaryTitle = Text.extend`
    margin: 10px 30px;
    text-align: center;
`;

class ApparatusFuelConfirmation extends Component {
    constructor(props) {
        super(props);

        this.state = {
            submitting: false
        };

        this.cancelLog = this.cancelLog.bind(this);
        this.confirmLog = this.confirmLog.bind(this);
        this.requestLog = this.requestLog.bind(this);
    }

    cancelLog() {
        this.props.history.push('/');
    }

    confirmLog() {
        let maintenanceLog = {
            maintenanceTypeID: '-2147483637',
            maintenanceStatusID: '2',
            requestedByUserID: this.props.user.userID,
            doneByUserID: this.props.user.userID,
            completedDate: this.props.date,
            maintenanceComplete: '1',
            requestMaintenanceDate: this.props.date,
            completedNotes: this.props.form.notes,
            odometerCompleted: this.props.form.odometer.replace(/,/g, ''),
            engineHoursCompleted: this.props.form.apparatusHours.replace(/,/g, ''),
            fuelVolume: this.props.form.fuelVolume.replace(/,/g, ''),
            DEFVolume: this.props.form.DEFVolume.replace(/,/g, ''),
            departmentApparatusID: this.props.loggingApparatus.departmentApparatusID,
            otherCost: this.props.form.cost
        };

        this.props.online ? this.requestLog(maintenanceLog) : this.props.cacheLog(maintenanceLog);
        this.props.onConfirm();
    }

    requestLog(maintenanceLog) {
        this.setState({ submitting: true });
        this.props.api
            .post(`/apparatuses/${maintenanceLog.departmentApparatusID}/maintenance`, maintenanceLog)
            .then(() => {
                this.props.history.push('/success');
            })
            .catch(err => {
                console.error(err);
            });
    }

    render() {
        if (!this.props.loggingApparatus.apparatusID) {
            return <Redirect to="/" />;
        }

        return (
            <ConfirmationContainer column>
                {this.state.submitting ? (
                    <Loader>
                        <Text>Uploading</Text>
                    </Loader>
                ) : (
                    <ConfirmationContent column>
                        <SummarySection column>
                            <IconContainer>
                                <FuelerIcon icon="checklist" size="100%" />
                            </IconContainer>
                            <SummaryTitle fontSize="24px">
                                {this.props.loggingApparatus.apparatusID || 'No Engine'}&nbsp;Fueling Summary
                            </SummaryTitle>
                            <LogSummary
                                date={this.props.date}
                                fuelVolume={this.props.form.fuelVolume}
                                DEFVolume={this.props.form.DEFVolume}
                                cost={this.props.form.cost}
                                odometer={this.props.form.odometer}
                                apparatusHours={this.props.form.apparatusHours}
                                notes={this.props.form.notes}
                            />
                        </SummarySection>
                        <ButtonRow>
                            <SubmitButton primary height="60px" width="50%" onClick={this.confirmLog}>
                                <Flex>
                                    <UploadIcon width="35px" fill="#fff" icon="upload" />
                                    <Text>Submit</Text>
                                </Flex>
                            </SubmitButton>
                            <CancelButton height="60px" width="35%" onClick={this.cancelLog}>
                                Cancel
                            </CancelButton>
                        </ButtonRow>
                    </ConfirmationContent>
                )}
            </ConfirmationContainer>
        );
    }
}

ApparatusFuelConfirmation.propTypes = {
    loggingApparatus: PropTypes.object.isRequired,
    cacheLog: PropTypes.func.isRequired
};

export default ApparatusFuelConfirmation;



// WEBPACK FOOTER //
// ./src/ApparatusFuelConfirmation/ApparatusFuelConfirmation.js